import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import { REWARDS_HUB_ROUTE } from '@leagueplatform/manulife-web-extensions';

export enum NavIds {
  HOME = 'HOME',
  JOURNEY = 'JOURNEY',
  CARE = 'GET_CARE',
  ABOUT_ME = 'ABOUT_ME',
  CARE_COLLECTIONS = 'CARE_COLLECTIONS',
  AWAY = 'AWAY',
  CARE_DISCOVERY = 'CARE_DISCOVERY',
  HEALTH_JOURNEY = 'HEALTH_JOURNEY',
  HEALTH_PROGRAMS = 'HEALTH_PROGRAMS',
  MASONRY_CONTAINER = 'MASONRY_CONTAINER',
  REWARDS_HUB = 'REWARDS_HUB',
}

export enum LinkType {
  NAV = 'navLink',
  LINK = 'link',
}

type NavItem = {
  to:
    | string
    | {
        search: string;
        pathname: string;
        state: unknown;
        hash: string;
        key?: string | undefined;
      };
};

export interface NavLink extends NavItem {
  message_id: NavIds;
  type: LinkType;
}

export const useNavLinksList = () => {
  const NavLinksList: NavLink[] = [
    {
      to: '/',
      message_id: NavIds.HOME,
      type: LinkType.NAV,
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.careDiscovery),
      message_id: NavIds.CARE,
      type: LinkType.NAV,
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.careCollections),
      message_id: NavIds.CARE_COLLECTIONS,
      type: LinkType.NAV,
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.healthJourney),
      message_id: NavIds.HEALTH_JOURNEY,
      type: LinkType.NAV,
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.healthPrograms),
      message_id: NavIds.HEALTH_PROGRAMS,
      type: LinkType.NAV,
    },
    {
      to: `/gb/member-portal/secured/member${REWARDS_HUB_ROUTE}`,
      message_id: NavIds.REWARDS_HUB,
      type: LinkType.NAV,
    },
    {
      to: '/away',
      message_id: NavIds.AWAY,
      type: LinkType.NAV,
    },
    {
      to: '/masonry-container-view',
      message_id: NavIds.MASONRY_CONTAINER,
      type: LinkType.NAV,
    },
  ];

  return {
    navLinks: NavLinksList,
  };
};
